module.exports = __webpack_public_path__ + "img/pro_two_2.b88ba03e.jpg";